import removeConversationData from "./helpers/removeConversationData";
import removeItemData from "./helpers/removeItemData";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { setSelectionOnRow } from "owa-mail-actions/lib/setSelectionOnRow";
import { updateAnchorRowKeyOnRemovalMutator } from "owa-mail-list-store";
import type TableView from "owa-mail-list-store/lib/store/schema/TableView";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";

export default function removeRowData(rowKey: string, tableView: TableView): void {
    // 1. If the row being removed is selected, remove item from selected item ids.
    // This should be done before we delete tableRowRelationKey as this sets
    // isSelected property on it.
    if (tableView.selectedRowKeys.has(rowKey)) {
        setSelectionOnRow(rowKey, tableView.id, false /* shouldSelect */); // this is a mutator
    }
    
    // 2. If the row being removed is the multi-selection anchor row key, move the anchor to a row that is
    // still in the table. This must happen while the row is still in rowKeys.
    if (isGlobalFeatureEnabled("tri-mlCheckboxBehavior")) {
        updateAnchorRowKeyOnRemovalMutator(tableView, rowKey);
    }
    
    // 3. Remove the row data
    switch (tableView.tableQuery.listViewType) {
        case 0:
            removeConversationData(rowKey, tableView); // this calls a mutators
            break;
        
        case 1:
            removeItemData(rowKey, tableView); // this calls a mutator
            break;
    }
}
